import { render, staticRenderFns } from "./hrd-add-menuitem.vue?vue&type=template&id=6764aea2&scoped=true"
import script from "./hrd-add-menuitem.vue?vue&type=script&lang=js"
export * from "./hrd-add-menuitem.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-menuitem.vue?vue&type=style&index=0&id=6764aea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6764aea2",
  null
  
)

export default component.exports